module.exports = __webpack_public_path__ + "static/img/WINDSOR-MAPLE.44564a6.png";


//////////////////
// WEBPACK FOOTER
// ./static/materials/cortina/WINDSOR-MAPLE.png
// module id = S5yt
// module chunks = 0